import "./APK.css"
import React from "react"
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useNavigate } from "react-router-dom"
export default function APK() {
    const nav=useNavigate()
    return (
        <>
           <div className='aff-menu'>
                <div className="aff-row-menu">
                    <div className='aff-row'>
                        <div className="aff-col">
                            <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                onClick={() => nav('/affiliate/create-aff-group')}
                            >
                                Log in to Affiliate account
                            </Button>
                        </div>
                        <div className="aff-col">
                            <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                onClick={() => nav('/affiliate/create-aff-group')}
                            >
                                Reset password
                            </Button>
                        </div>
                        <div className="aff-col">
                            <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                onClick={() => nav('/affiliate/details/bonus')}
                            >
                                pay bonus
                            </Button>
                        </div>
                        <div className="aff-col">
                            <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                onClick={() => nav('/affiliate/create-aff-group')}
                            >
                                Domain settings
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="aff-row-menu">
                    <div className='aff-row'>

                        <div className="aff-col">
                            <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                onClick={() => nav('/affiliate/create-aff-group')}
                            >
                                Fixed commissions
                            </Button>
                        </div>
                        <div className="aff-col">
                            <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                onClick={() => nav('/affiliate/details')}
                            >
                                Back
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        <div className="aff-apk-wp">
            <div className="aff-apk">
            <div className="promo-form-wp">
                <div className="promo-form">
                    <div className="promo-lbl">
                        Site
                    </div>
                    <div className="promo-in">

                        <select style={{ padding: 5, width: "100%" }} >
                            <option>All</option>
                        </select>
                    </div>
                </div>
                <div className="promo-form">
                    <div className="promo-lbl">
                        Currency
                    </div>
                    <div className="promo-in">
                        <select style={{ width: "100%", padding: 5 }} >
                            <option>USD</option>
                        </select>
                    </div>
                </div>
                <div className="promo-form">
                    <div className="promo-lbl">
                        Campaign
                    </div>
                    <div className="promo-in">
                        <select style={{ width: "100%", padding: 5 }} >
                            <option>ALl</option>
                        </select>
                    </div>
                </div>
                <div className="promo-form">
                    <div className="promo-lbl">
                    </div>
                    <div className="promo-in">
                        <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                        >
                            Download APK
                        </Button>
                    </div>
                </div>
            </div>
            </div>
        </div>
        </>
    )
}